import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { HttpHeaders } from '@angular/common/http';;
import { lastValueFrom } from 'rxjs';
import { TableAction } from 'src/app/shared/components/table-paginator/table-paginator.component';
import { UsuariosService } from 'src/app/core/services/usuarios.service';
import Swal from 'sweetalert2'
interface Item {
  id_user?: string;
  usuario: string;
  correo: string;
  estado: string;
}



@Component({
  selector: 'app-create-user',
  templateUrl: './create-group.component.html',
  styleUrls: ['./create-group.component.scss']
})
export class CreateGroupComponent implements OnInit {
  fullData: Item[] = []; // Tu conjunto completo de datos
  currentItems: Item[] = []; // Los datos para la página actual

  currentPage: number = 1;
  pageSize: number = 10; // Tamaño de página inicial
  totalItems: number = 0;



  tableHeaders = [
    { key: 'usuario', label: 'Usuario' },
    { key: 'correo', label: 'Correo' },
    { key: 'estado', label: 'Estado' }
  ];

  // Definición de las acciones personalizadas
  customActions: TableAction[] = [];

  //MODAL
  public closeResult: string;
  @ViewChild('createUser') referencecreateUser!: TemplateRef<any>;
  title = '';
  userForm!: FormGroup;
  addUser: boolean = false;
  udpUser: boolean = false;
  idUser: string;

  constructor(private formBuilder: UntypedFormBuilder,
    private usuarioService: UsuariosService,
    private modalService: NgbModal,
    private fb: FormBuilder
  ) {

  }


  ngOnInit() {
    this.initUserForm();
    this.getUser();

    // Configura las acciones personalizadas
    this.customActions = [
      {
        label: 'Editar',
        handler: (item: Item) => this.showUser(item.id_user),
        icon: 'fa-solid fa-pen-to-square',
        colorClass: 'bg-orange'
      },
    ];
  }

  initUserForm(): void {
    this.userForm = this.fb.group({
      username: ['', [Validators.required]],
      firstName: ['', [Validators.required, Validators.minLength(3)]],
      lastName: ['', [Validators.required, Validators.minLength(3)]],
      password: ['', [Validators.required, Validators.minLength(6)]], // Ejemplo de longitud mínima
      email: ['', [Validators.required, Validators.email]]
    });
  }

  async getUser() {
    const result = await lastValueFrom(this.usuarioService.getUsuarios(this.currentPage, this.pageSize));

    const headers: HttpHeaders = result.headers;
    this.currentItems = result.body.map((x: any, index: number) => {
      return { id_user: x.id, usuario: (x.username), correo: x.email, estado: (x.isActive == true ? 'Activo' : 'Inactivo') }
    });

    this.totalItems = Number(headers.get('X-Total-Count'));
  }

  async CreateUser() {
    const response = await lastValueFrom(this.usuarioService.createUsuario(this.userForm.value));

    if (response) {
      this.getUser();
      Swal.fire({
        title: 'Creado con éxito',
        text: response.message,
        icon: 'success',
        confirmButtonText: 'Ok'
      });
      this.modalService.dismissAll();
    }
  }

  async showUser(id: any) {
    const response = await lastValueFrom(this.usuarioService.getUsuario(id));
    this.openModal(this.referencecreateUser, 'edit', 'Editar Usuario');
    if (response) {
      this.idUser = response.body.id;
      this.userForm.patchValue({
        username: response.body.username,
        email: response.body.email,
        firstName: response.body.firstName,
        lastName: response.body.lastName
      });

    }
  }

  async updateUser() {
    const response = await lastValueFrom(this.usuarioService.updateUsuario( this.idUser, this.userForm.value));

    if (response) {
      this.getUser();
      Swal.fire({
        title: 'Actualización con éxito',
        text: response.message,
        icon: 'success',
        confirmButtonText: 'Ok'
      });
      this.modalService.dismissAll();
    }
  }

  /*
   FUNCIONES PARA EL MODAL
  */
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openModal(content: any, action: string, title: string) {

    this.userForm.reset();
    this.title = title;
    if (action == 'add') {
      this.addUser = true;
      this.udpUser = false;
    } else {
      
      this.addUser = false;
      this.udpUser = true;
    }

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.getUser();
  }

  onPageSizeChange(newSize: number): void {
    this.pageSize = newSize;
    this.currentPage = 1; // Siempre vuelve a la primera página al cambiar el tamaño
    this.getUser();
  }
}
